import { Tabs } from "@shared/ui/tabs";
import { useNavigate, useParams } from "react-router-dom";
import { RoutesTab } from "./tabs/routesTab/routesTab";
import { PremisesTab } from "./tabs/premisesTab/premisesTab";
import { MetersTab } from "./tabs/metersTab/metersTab";
import { ValidationEstimationsTab } from "./tabs/validationEstimationsTab/validationEstimationsTab";
import { ActivityLogTab } from "@features/mx/shared/components/ActivityLog";
import { NotesTab } from "@features/mx/shared/components/NotesTab";


const urlMapping = {
  routes: "routes",
  premises: "premises",
  meters: "meters",
  validationEstimations: "validation-estimations",
  activityLog: "activity-log",
  notes: "notes",
};

export const ReadCycleEntitiesTab = ({ data }: { data: any }) => {
  const { cycle_id } = useParams();
  const source = "2";

  const tabComponents = {
    routes: {
      label: "Routes",
      shortLabel: "Routes",
      component: <RoutesTab />,
    },
    premises: {
      label: "Premises",
      shortLabel: "Premises",
      component: <PremisesTab readCycleData={data} />,
    },
    meters: {
      label: "Meters",
      shortLabel: "Meters",
      component: <MetersTab />,
    },
    validationEstimations: {
      label: "Validation & Estimations",
      shortLabel: "Validation & Estimations",
      component: <ValidationEstimationsTab readCycleData={data} />,
    },
    notes: {
      label: "Notes",
      component: (
        <NotesTab requestId={cycle_id} source={source} title="System" />
      ),
    },
    activityLog: {
      label: "Activity Log",
      shortLabel: "Activity Log",
      component: <ActivityLogTab entityId={cycle_id} entityType={source} />,
    },
  };

  return (
    <div>
      <Tabs
        defaultValue="routes"
        urlMapping={urlMapping}
        tabComponents={tabComponents}
        tabsListClassName="grid w-full grid-cols-6 mb-6"
        idPrefix="readCycle-tab"
        level={1}
      />
    </div>
  );
};
